import * as React from 'react';

import CircularProgressMui from '@mui/material/CircularProgress';

import { color } from '../../utils';

type Props = {
  className?: string;
  variant?: string;
};

export const CircularProgress: React.FC<Props> = ({ className = '', variant }) => {
  const style = variant ? styles[variant] : '';

  return (
    <div className={`flex justify-center ${style} ${className}`}>
      <CircularProgressMui sx={{ color: color('dark-gray', 'light') }} />
    </div>
  );
};

const styles: Record<string, string> = {
  full: `absolute w-full`,
};
